import { Box, IconButton, Modal } from "@mui/material";
import { NeutralColor } from "node-library/dist/colors";
import CloseIcon from "@mui/icons-material/Close";
import { CustomIconButton } from "../button";

interface ModalWithButtonsProp {
	headerText: string;
	headerDescription?: string;
	open: boolean;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;
	children: React.ReactNode;
	buttons: Array<React.ReactNode>;
	modalWidth?: number | string;
	hideHeader?: boolean;
}

function ModalWithButtons(props: ModalWithButtonsProp) {
	const modelStyle = {
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		width: props.modalWidth || 400,
		bgcolor: "background.paper",

		borderRadius: "8px",
		boxShadow: 12,
		paddingTop: "16px",
		"@media (max-width: 600px)": {
			width: "90%", // Set width to 90% for mobile screens
		},
		"@media": {
			maxHeight: "90%", // Set max height to 90% for mobile screens
			overflow: "auto",
		},
	};
	return (
		<Modal open={props.open} onClose={() => props.setOpen(false)}>
			<Box sx={modelStyle}>
				{!props.hideHeader && (
					<div className="modal-header">
						<div className="modal-header-text-container">
							<div className="typography-heading-03 overflow-ellipsis-text">
								{props.headerText}
							</div>
							{props.headerDescription && (
								<div
									className="typography-caption"
									style={{
										color: NeutralColor.NEUTRAL_GREY_500,
									}}
								>
									{props.headerDescription}
								</div>
							)}
						</div>
						<CustomIconButton
							onClick={() => props.setOpen(false)}
							icon={<CloseIcon />}
							size="medium"
							id={"modal-close-button"}
						></CustomIconButton>
					</div>
				)}
				<div className="modal-body">{props.children}</div>
				<div className="modal-footer">{props.buttons}</div>
			</Box>
		</Modal>
	);
}

export { ModalWithButtons };
